import { LabelColor } from '~components/@ui/label/types';
import Consultation from '~features/consultation/models';

export const labelColor: { [key in Consultation.State]: LabelColor } = {
  [Consultation.State.Pending]: 'gray',
  [Consultation.State.Answered]: 'green',
  [Consultation.State.Additional]: 'gray',
  [Consultation.State.Occupied]: 'gray'
};
